import React from 'react'

export default function AmericanStates() {
    return (
        <>
            <option value=""></option>
            <option value="AL">alabama</option>
            <option value="AK">alaska</option>
            <option value="AZ">arizona</option>
            <option value="AR">arkansas</option>
            <option value="CA">california</option>
            <option value="CO">colorado</option>
            <option value="CT">connecticut</option>
            <option value="DE">delaware</option>
            <option value="DC">district of columbia</option>
            <option value="FL">florida</option>
            <option value="GA">georgia</option>
            <option value="HI">hawaii</option>
            <option value="ID">idaho</option>
            <option value="IL">illinois</option>
            <option value="IN">indiana</option>
            <option value="IA">iowa</option>
            <option value="KS">kansas</option>
            <option value="KY">kentucky</option>
            <option value="LA">louisiana</option>
            <option value="ME">maine</option>
            <option value="MD">maryland</option>
            <option value="MA">massachusetts</option>
            <option value="MI">michigan</option>
            <option value="MN">minnesota</option>
            <option value="MS">mississippi</option>
            <option value="MO">missouri</option>
            <option value="MT">montana</option>
            <option value="NE">nebraska</option>
            <option value="NV">nevada</option>
            <option value="NH">new hampshire</option>
            <option value="NJ">new jersey</option>
            <option value="NM">new mexico</option>
            <option value="NY">new york</option>
            <option value="NC">north carolina</option>
            <option value="ND">north dakota</option>
            <option value="OH">ohio</option>
            <option value="OK">oklahoma</option>
            <option value="OR">oregon</option>
            <option value="PA">pennsylvania</option>
            <option value="RI">rhode island</option>
            <option value="SC">south carolina</option>
            <option value="SD">south dakota</option>
            <option value="TN">tennessee</option>
            <option value="TX">texas</option>
            <option value="UT">utah</option>
            <option value="VT">vermont</option>
            <option value="VA">virginia</option>
            <option value="WA">washington</option>
            <option value="WV">west virginia</option>
            <option value="WI">wisconsin</option>
            <option value="WY">wyoming</option>
        </>
    )
}
